module.exports = __webpack_public_path__ + "static/media/facebook.8eaa8ca9.svg";